import { map } from "lodash";
import { AiccTestAccountCandidateResponse, AiccTestAccountResponse } from "../dto/response/aiccTestAccount";
import { AiccTestAccount, AiccTestAccountCandidate } from "../model/aiccTestAccount";
import { DEFAULT_SUB_USER_NAME } from "./aiccCustomer";

export function transformAiccTestAccount(response: AiccTestAccountResponse): AiccTestAccount {
  return {
    customerId: response.customer_id,
    customerEmail: response.email ?? "",
    messageQuota: response.preview_quota?.limit ?? 0,
    messageUsage: response.preview_quota?.used ?? 0,
    subUsers: map(response.preview_sub_users, ({ id, name }) => ({ id, name: name || DEFAULT_SUB_USER_NAME })),
    hasAccess: response.preview_access ?? false,
  };
}

export function transformAiccTestAccountList(response?: AiccTestAccountResponse[]): AiccTestAccount[] {
  return map(response, transformAiccTestAccount);
}

export function transformAiccTestAccountCandidateList(
  response?: AiccTestAccountCandidateResponse[]
): AiccTestAccountCandidate[] {
  return map(response, ({ customer_id: customerId, customer_email: customerEmail }) => ({
    customerId,
    customerEmail,
  }));
}
